import styled from 'styled-components';

const MyDiv = styled.div`
   .empId {
    text-decoration: underline;
    color: rgba(0, 122, 255, 1);
    display: inline-flex;
    align-items: center;
    padding: 4px 8px; 
    border-radius: 16px;
    cursor: pointer;
    white-space: nowrap; 
    cursor: pointer;
  }

  .filter_section {
    display: flex;
    gap: 10px;
  }

`;


export default MyDiv;